import { isActionColumn, ActionCellContent } from './ActionColumn.js';
import { DataCellContent } from './DataColumn.js';
import { isGroupColumn } from './GroupColumn.js';
import { PrimaryCellContent, PrimaryHeaderCellContent } from './PrimaryColumn.js';
import styles from './Table.module.scss.js';
import { nextSortDir, sortIcons } from './util.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { UNSAFE_Icon } from '../icon/Icon.js';
import { Text } from '../text/Text.js';
import classNames from 'clsx';
import { isAffirmativeKeypress } from '../util/aria.js';

function makeColumnDef(col, i) {
  if (isGroupColumn(col)) {
    const def = {
      id: col.key,
      meta: col,
      header: HeaderCellContent,
      columns: col.columns.map((c, si) => makeColumnDef(c, i + si))
    };
    return def;
  }
  if (isActionColumn(col)) {
    const def = {
      accessorKey: col.key,
      meta: col,
      header: HeaderCellContent,
      cell: ActionCellContent
    };
    return def;
  }
  const def = {
    accessorKey: col.key,
    meta: col,
    header: i === 0 ? PrimaryHeaderCellContent : HeaderCellContent,
    cell: i === 0 ? PrimaryCellContent : DataCellContent
  };
  return def;
}
function isDataColumn(x) {
  return !isActionColumn(x) && !isGroupColumn(x);
}
function HeaderCellContent(ctx) {
  const meta = ctx.column.columnDef.meta;
  if (ctx.header.isPlaceholder) {
    return null;
  }
  const {
    sorting,
    size
  } = ctx.table.options.meta;
  const thisSort = sorting?.[meta.key];
  const className = classNames(styles['header-cell-content'], meta.align && styles[`header-${meta.align}`]);
  const sortIconEl = thisSort && /*#__PURE__*/jsx(UNSAFE_Icon, {
    icon: sortIcons[thisSort],
    className: styles['icon-only']
  });
  const headerEl = meta.iconOnly ? /*#__PURE__*/jsx(UNSAFE_Icon, {
    icon: meta.icon,
    title: meta.heading,
    className: styles['icon-only']
  }) : /*#__PURE__*/jsx(Text, {
    icon: meta.icon,
    variant: size === 'small' ? 'table-header-small' : 'table-header',
    children: meta.heading
  });
  const sortHandlers = sortIconEl ? {
    role: 'button',
    tabIndex: 0,
    onClick: () => meta.onSort?.(nextSortDir(thisSort)),
    onKeyDown: isAffirmativeKeypress(() => meta.onSort?.(nextSortDir(thisSort)))
  } : {};
  return /*#__PURE__*/jsx("div", {
    className: className,
    ...sortHandlers,
    children: /*#__PURE__*/jsxs("div", {
      className: styles['header-label-and-sort'],
      children: [headerEl, sortIconEl]
    })
  });
}

export { HeaderCellContent, isDataColumn, makeColumnDef };
